import Request from "../../shared/utils/_request";

class Account {
  constructor() { }
  //登录
  login(payload) {
    return Request.post("/account/login", payload);
  }
  /**
   * token 获取用户信息
   * @param {*} payload
   */
  doLogin(payload) {
    return Request.post("/account/get-item", payload);
  }
  /**
   * 退出登录
   */
  logout(payload) {
    return Request.post("/account/logout", payload);
  }
  suggest(payload) {
    return Request.post("/account/suggest", payload);
  }

  // 消息
  messageList(payload) {
    return Request.post("/message/get-list", payload);
  }
  alreadyRead(payload) {
    return Request.post("/message/set-all-read", payload);
  }
  getUnReadCount() {
    return Request.post("message/getUnReadCount");
  }
  /**
   * 员工数据转移
   * @param {{from_user_id, to_user_id}} payload 
   */
  tranfromUserInfo(payload) {
    return Request.post('/account/transform-data', payload)
  }
}

export const account = new Account();
